/* VITALLY · Test de orientación (solo en la página del test). Sigue la
   especificación validada: una pregunta por pantalla con 4 tarjetas y
   avance automático al elegir (sin «Continuar»); cada respuesta suma el peso de su pregunta a un programa;
   empates por las preguntas de desempate y luego por el orden de los bloques;
   datos breves al final; resultado con la afinidad (%) de cada programa, la guía del
   principal con un solo botón y la ruta hacia el segundo (maquetas del cliente, 23-oct).
   Los textos, preguntas y programas llegan de la sección «Test VITALLY». */
(function () {
  "use strict";
  var caja = document.querySelector("[data-test]");
  var fuente = document.querySelector("[data-test-config]");
  if (!caja || !fuente) return;
  var reducido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var cfg = JSON.parse(fuente.textContent);
  var T = cfg.textos;
  var R = cfg.resultado || {};
  var P = cfg.preguntas.filter(function (q) { return q.q && q.ops.length; });
  var A = cfg.areas.filter(function (a) { return a.codigo; });
  var marcaEl = document.querySelector("[data-test-marca]");
  var marca = marcaEl ? marcaEl.innerHTML : "";
  var CLAVE = "vitally-test";

  var esc = function (t) {
    return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  var lista = function (t, sep) {
    return String(t || "").split(sep).map(function (x) { return x.trim(); }).filter(Boolean);
  };
  // [texto](url) → enlace
  var marcas = function (t) {
    return esc(t).replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener" class="font-bold text-orooscuro underline decoration-oro/40 underline-offset-2">$1</a>');
  };
  // Preguntas de desempate (1-based en el ajuste) → índices
  var desempate = lista(T.desempate, ",").map(function (n) { return Number(n) - 1; }).filter(function (i) { return i >= 0 && i < P.length; });

  var paso = -1;
  var resp = P.map(function () { return null; });
  var avance = null;
  var CLASE_ON = "border-oro bg-marfil text-tinta shadow-[0_18px_36px_-22px_rgba(138,103,22,0.6)]".split(" ");
  var CLASE_OFF = "border-pergamino bg-marfil text-tinta/90 hover:-translate-y-0.5 hover:border-oro/60 hover:shadow-[0_18px_36px_-26px_rgba(20,32,26,0.45)]".split(" ");
  // Ícono de cada área (los pinta la sección en <template data-test-iconos>)
  var iconos = {};
  var plantillaIconos = document.querySelector("[data-test-iconos]");
  if (plantillaIconos) {
    plantillaIconos.content.querySelectorAll("[data-area]").forEach(function (el) { iconos[el.getAttribute("data-area")] = el.innerHTML; });
  }
  var datos = { edad: "", pais: "", genero: "", correo: "", autorizo: false, novedades: false };
  var envio = ""; // "", "enviando", "ok", "error"
  var inicio = 0;

  function medir(evento, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: "test_vitally_" + evento }, extra || {}));
    } catch (e) {}
  }

  // Progreso temporal en esta pestaña, para recuperar una interrupción
  function guardar() {
    try {
      sessionStorage.setItem(CLAVE, JSON.stringify({ paso: paso === 90 ? 80 : paso, resp: resp, datos: datos, envio: envio, inicio: inicio }));
    } catch (e) {}
  }
  function recuperar() {
    try {
      var g = JSON.parse(sessionStorage.getItem(CLAVE) || "null");
      if (!g || !Array.isArray(g.resp) || g.resp.length !== P.length) return;
      resp = g.resp.map(function (r, i) { return typeof r === "number" && P[i].ops[r] ? r : null; });
      datos = Object.assign(datos, g.datos || {});
      envio = g.envio === "ok" || g.envio === "error" || g.envio === "enviando" ? g.envio : "";
      inicio = g.inicio || 0;
      var p = typeof g.paso === "number" ? g.paso : -1;
      if (p === 99 && resp.some(function (r) { return r === null; })) p = -1;
      if (p > 0 && p < P.length && resp[p - 1] === null) p = resp.indexOf(null);
      paso = p;
    } catch (e) {}
  }

  // ---- Puntaje, orden y afinidad ------------------------------------------
  function puntos() {
    var suma = {};
    resp.forEach(function (r, i) {
      if (r === null) return;
      var areas = P[i].ops[r].areas.filter(Boolean);
      if (!areas.length) return;
      var parte = P[i].peso / areas.length;
      areas.forEach(function (a) { suma[a] = (suma[a] || 0) + parte; });
    });
    return suma;
  }
  // El mejor programa fuera de «fuera»: más puntos; si empatan, las preguntas de desempate.
  function ganador(fuera) {
    var suma = puntos();
    var candidatas = A.filter(function (a) { return fuera.indexOf(a.codigo) === -1; });
    if (!candidatas.length) return null;
    var max = Math.max.apply(null, candidatas.map(function (a) { return suma[a.codigo] || 0; }));
    var empatadas = candidatas.filter(function (a) { return (suma[a.codigo] || 0) === max; });
    if (empatadas.length === 1) return { a: empatadas[0], pts: max };
    for (var k = 0; k < desempate.length; k++) {
      var i = desempate[k];
      if (resp[i] === null) continue;
      var elegidas = P[i].ops[resp[i]].areas;
      var gana = empatadas.filter(function (a) { return elegidas.indexOf(a.codigo) !== -1; });
      if (gana.length === 1) return { a: gana[0], pts: max };
      if (gana.length > 1) empatadas = gana;
    }
    return { a: empatadas[0], pts: max }; // orden técnico fijo = orden de los bloques
  }
  // Todos los programas de mayor a menor, con la misma regla en cada puesto.
  function ranking() {
    var lista = [];
    var fuera = [];
    for (var g = ganador(fuera); g; g = ganador(fuera)) { lista.push(g); fuera.push(g.a.codigo); }
    return lista;
  }
  // Afinidad = puntos del programa ÷ puntos repartidos, en % redondeado. Mismos puntos, mismo
  // porcentaje (por eso la suma puede dar 99 o 101: son barras independientes, no una torta).
  function afinidad(lista) {
    var total = lista.reduce(function (t, x) { return t + x.pts; }, 0);
    return lista.map(function (x) { return total ? Math.round((x.pts / total) * 100) : 0; });
  }
  function resultadoCalculado() {
    var lista = ranking();
    var pct = afinidad(lista);
    return {
      principal: lista[0] || null,
      segundo: lista[1] || null,
      lista: lista.map(function (x, i) { return { a: x.a, pts: x.pts, pct: pct[i] }; }),
    };
  }

  // ---- Envío a la tienda --------------------------------------------------
  // Con la casilla de novedades (o con «Registrar como cliente: todos» en la sección)
  // la persona queda en Clientes de Shopify, etiquetada con su resultado; si no, llega
  // como mensaje de contacto. Se envía el formulario de Shopify de forma NATIVA con su
  // captcha (Shopify.captcha.protect): por fetch la tienda lo rechaza (anti-spam) y el
  // correo se perdía. La tienda vuelve a esta página con ?customer_posted=true o
  // ?contact_posted=true y el resultado se retoma de sessionStorage (ver «Vuelta del envío»).
  var slug = function (t) { return String(t || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""); };
  function enviarLead() {
    var r = resultadoCalculado();
    if (!r.principal) return false;
    var p = r.principal.a;
    var s = r.segundo ? r.segundo.a : null;
    var cliente = datos.novedades || T.registro === "siempre";
    var form = document.getElementById(cliente ? "qz-envio-cliente" : "qz-envio-contacto");
    if (!form) { envio = "error"; guardar(); return false; }
    var poner = function (nombre, valor) {
      var el = form.querySelector('[name="' + nombre + '"]');
      if (el) el.value = valor;
    };
    poner("contact[email]", datos.correo);
    if (cliente) {
      poner("contact[tags]", ["test-vitally", "programa-" + slug(p.nombre), s ? "secundaria-" + slug(s.nombre) : "", "edad-" + slug(datos.edad),
        "pais-" + slug(datos.pais), "genero-" + slug(datos.genero), "novedades-" + (datos.novedades ? "si" : "no")].filter(Boolean).join(","));
    } else {
      poner("contact[name]", "Test " + cfg.marca);
      poner("contact[body]", "Test " + cfg.marca + "\nPrograma recomendado: " + p.nombre + (s ? "\nPrioridad secundaria: " + s.nombre : "") +
        "\nAfinidad: " + r.lista.map(function (x) { return x.a.nombre + " " + x.pct + " %"; }).join(", ") +
        "\nEdad: " + datos.edad + "\nPaís: " + datos.pais + "\nGénero: " + datos.genero +
        "\nAutoriza datos para el resultado: sí\nAcepta novedades y publicidad: " + (datos.novedades ? "sí" : "no"));
    }
    envio = "enviando";
    paso = 99; // al volver de la tienda se muestra el resultado
    guardar();
    medir("registro", { tipo: cliente ? "cliente" : "contacto" });
    var enviado = false;
    // form.submit() y no el del prototipo: Shopify.captcha.protect le pone al formulario
    // su propio submit(), que primero saca el token del captcha.
    // Si el captcha no llega a dar su token (bloqueador, red lenta), a los 12 s se envía sin
    // él y la tienda muestra su reto (/challenge): nunca se queda en «calculando».
    var saliendo = false;
    window.addEventListener("beforeunload", function () { saliendo = true; });
    var mandar = function () {
      if (enviado) return;
      enviado = true;
      form.submit();
      setTimeout(function () { if (!saliendo) HTMLFormElement.prototype.submit.call(form); }, 12000);
    };
    try {
      if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === "function") {
        Shopify.captcha.protect(form, mandar);
        setTimeout(mandar, 8000); // si el captcha no responde, se envía igual (la tienda pedirá el reto)
        return true;
      }
    } catch (e) {}
    mandar();
    return true;
  }

  // ---- Pantallas ----------------------------------------------------------
  function barra(n, clase) {
    return '<div class="' + clase + ' h-1.5 overflow-hidden rounded-full bg-pergamino" role="progressbar" aria-valuemin="0" aria-valuemax="' + P.length + '" aria-valuenow="' + n + '">' +
      '<div class="h-full rounded-full bg-gradient-to-r from-orooscuro to-oroclaro transition-all duration-500" style="width:' + (n / P.length) * 100 + '%"></div></div>';
  }

  // La portada la arma la sección (bloque «Portada») en una plantilla; aquí solo se copia.
  var plantillaPortada = document.querySelector("[data-test-portada]");
  function portada() {
    return plantillaPortada ? plantillaPortada.innerHTML : '<button type="button" data-q="empezar" class="btn btn-oro"><span class="relative z-10">&rarr;</span></button>';
  }

  function pregunta(aviso) {
    var q = P[paso];
    var ops = q.ops.map(function (op, i) {
      var activa = resp[paso] === i;
      var icono = iconos[(op.areas[0] || "").toUpperCase()] || "";
      return '<button type="button" data-op="' + i + '" aria-pressed="' + activa + '" class="qz-op group flex min-h-[4.6rem] items-center gap-4 rounded-2xl border py-3 pl-3 pr-4 text-left transition duration-200 sm:min-h-[5.25rem] ' +
        (activa ? CLASE_ON : CLASE_OFF).join(" ") + '">' +
        '<span aria-hidden="true" class="grid h-12 w-12 flex-none place-items-center rounded-xl bg-gradient-to-br from-oro/25 to-oro/5 text-orooscuro ring-1 ring-oro/25 transition-colors duration-200 group-aria-pressed:from-bosque group-aria-pressed:to-selva group-aria-pressed:text-oro group-aria-pressed:ring-bosque">' + icono + "</span>" +
        '<span class="flex-1 text-[0.98rem] font-semibold leading-snug">' + esc(op.t) + "</span>" +
        '<span aria-hidden="true" class="qz-op-marca grid h-6 w-6 flex-none place-items-center rounded-full border-2 border-pergamino text-crema transition-colors duration-200 group-hover:border-oro/60 group-aria-pressed:border-bosque group-aria-pressed:bg-bosque">' + (iconos.check || "") + "</span></button>";
    }).join("");
    return '<div class="qz-step card-luz mx-auto max-w-3xl p-6 sm:p-10"><div class="flex items-center justify-between gap-4">' +
      '<button type="button" data-q="atras" class="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-[0.14em] text-humo transition-colors hover:text-tinta">← ' + esc(T.atras) + "</button>" +
      '<span class="text-xs font-bold uppercase tracking-[0.18em] text-humo">' + esc((T.de || "").replace("[n]", paso + 1).replace("[total]", P.length)) + "</span></div>" +
      barra(paso + 1, "mt-4") +
      '<h2 tabindex="-1" class="font-display mt-7 text-2xl font-extrabold leading-snug text-tinta outline-none sm:text-[1.7rem]">' + esc(q.q) + "</h2>" +
      '<div class="mt-7 grid gap-3 sm:grid-cols-2 sm:gap-4" role="group" aria-label="' + esc(q.q) + '">' + ops + "</div>" +
      (aviso ? '<p data-q-aviso role="alert" class="mt-6 text-sm font-semibold text-[#8c2f1f]">' + esc(T.elige_error) + "</p>" : "") + "</div>";
  }

  function campo(id, etiqueta, control, ayuda) {
    return '<div class="mt-5"><label for="' + id + '" class="block text-sm font-bold text-tinta">' + esc(etiqueta) + "</label>" + control +
      '<p data-ayuda="' + id + '" class="mt-1.5 text-xs leading-relaxed text-humo">' + esc(ayuda) + "</p></div>";
  }
  function opcionesSelect(items, actual) {
    return items.map(function (x) { return '<option value="' + esc(x) + '"' + (x === actual ? " selected" : "") + ">" + esc(x) + "</option>"; }).join("");
  }

  function pasoDatos() {
    var clase = "campo mt-2 px-4 text-[1rem] text-tinta";
    var edades = lista(T.edad_opciones, ";");
    var generos = lista(T.genero_opciones, ";");
    var destacados = lista(T.paises_destacados, ",");
    var todos = lista(T.paises, ",").filter(function (p) { return destacados.indexOf(p) === -1; });
    var paisSelect = '<select id="qz-pais" name="pais" class="' + clase + '" required><option value="">' + esc(T.pais_vacio) + "</option>" +
      (destacados.length ? "<optgroup label=\"—\">" + opcionesSelect(destacados, datos.pais) + "</optgroup>" : "") +
      (todos.length ? "<optgroup label=\"———\">" + opcionesSelect(todos, datos.pais) + "</optgroup>" : "") + "</select>";
    var generoRadios = '<div id="qz-genero" role="radiogroup" aria-label="' + esc(T.genero_label) + '" class="mt-2 grid gap-2 sm:grid-cols-3">' +
      generos.map(function (g, i) {
        var on = datos.genero === g;
        return '<label class="flex cursor-pointer items-center gap-2 rounded-2xl border px-4 py-3 text-sm font-semibold transition-colors ' + (on ? "border-oro bg-oro/15 text-tinta" : "border-pergamino bg-marfil text-tinta/85 hover:border-oro/60") + '">' +
          '<input type="radio" name="genero" value="' + esc(g) + '"' + (on ? " checked" : "") + ' class="h-4 w-4 accent-[#7d6020]"' + (i === 0 ? ' id="qz-genero-0"' : "") + ">" + esc(g) + "</label>";
      }).join("") + "</div>";
    return '<div class="qz-step card-luz marco-oro mx-auto max-w-2xl p-8 sm:p-12"><div class="text-center"><div class="mx-auto w-fit">' + marca + "</div>" +
      '<h2 tabindex="-1" class="font-display mt-5 text-balance text-3xl font-extrabold text-tinta outline-none">' + esc(T.datos_titulo) + "</h2></div>" +
      '<form data-q="datos" class="mx-auto mt-6 max-w-md" novalidate>' +
      campo("qz-edad", T.edad_label, '<select id="qz-edad" name="edad" class="' + clase + '" required><option value="">—</option>' + opcionesSelect(edades, datos.edad) + "</select>", T.edad_ayuda) +
      campo("qz-pais", T.pais_label, paisSelect, T.pais_ayuda) +
      campo("qz-genero-0", T.genero_label, generoRadios, T.genero_ayuda) +
      campo("qz-email", T.correo_label, '<input id="qz-email" name="correo" type="email" inputmode="email" autocomplete="email" placeholder="nombre@correo.com" value="' + esc(datos.correo) + '" class="' + clase + '" required>', T.correo_ayuda) +
      '<label class="mt-6 flex cursor-pointer items-start gap-3 text-sm leading-relaxed text-tinta"><input type="checkbox" id="qz-autorizo" name="autorizo" class="mt-0.5 h-5 w-5 flex-none accent-[#7d6020]"' + (datos.autorizo ? " checked" : "") + ' required>' +
      "<span>" + marcas(T.autorizo) + "</span></label>" +
      '<p data-ayuda="qz-autorizo" class="ml-8 mt-1 text-xs text-humo"></p>' +
      // Con «Registrar como cliente: todos» la casilla obligatoria ya incluye las comunicaciones: no hay casilla aparte.
      (T.registro === "siempre" ? "" : '<label class="mt-3 flex cursor-pointer items-start gap-3 text-sm leading-relaxed text-humo"><input type="checkbox" id="qz-novedades" name="novedades" class="mt-0.5 h-5 w-5 flex-none accent-[#7d6020]"' + (datos.novedades ? " checked" : "") + ">" +
      "<span>" + esc(T.novedades) + "</span></label>") +
      '<button type="submit" class="btn btn-oro mt-7 w-full"><span class="relative z-10">' + esc(T.ver_resultado) + "</span></button></form></div>";
  }

  function calculando() {
    return '<div class="qz-step card-luz mx-auto max-w-2xl p-12 text-center"><div class="mx-auto w-fit animate-pulse">' + marca + "</div>" +
      '<p class="font-display mt-6 text-2xl font-bold text-tinta">' + esc(T.calculando) + "</p></div>";
  }

  // Foto de la guía de cada programa (la pinta la sección en <template data-test-fotos>)
  var fotos = {};
  var plantillaFotos = document.querySelector("[data-test-fotos]");
  if (plantillaFotos) {
    plantillaFotos.content.querySelectorAll("[data-area]").forEach(function (el) { fotos[el.getAttribute("data-area")] = el.innerHTML; });
  }
  // [programa], [area], [empieza] y [despues] en los textos del bloque «Resultado»
  function rellenar(t, a, s) {
    return esc(t).replace(/\[programa\]/g, esc(a.nombre)).replace(/\[area\]/g, esc(a.area))
      .replace(/\[empieza\]/g, esc(a.empieza)).replace(/\[despues\]/g, esc(s ? s.despues : ""));
  }
  var ROTULO = "font-brand text-[0.66rem] font-bold uppercase tracking-[0.22em]";
  // Del primero al último: oro y luego el verde de la marca cada vez más suave.
  var TONOS = ["bg-oro", "bg-bosque/60", "bg-bosque/35", "bg-bosque/15"];

  function mapa(r) {
    // Eje de 0 al siguiente múltiplo de 25 sobre el mayor (50, 75 o 100), con sus valores a la
    // vista: las barras llenan la tarjeta sin inflar ningún porcentaje.
    var mayor = r.lista.reduce(function (m, x) { return Math.max(m, x.pct); }, 0);
    var tope = Math.min(100, Math.max(25, Math.ceil(mayor / 25) * 25));
    var columnas = r.lista.map(function (x, i) {
      var primero = i === 0;
      var alto = Math.round((x.pct / tope) * 1000) / 10;
      return '<li class="relative flex flex-col items-center rounded-2xl px-1 pb-4 pt-3' + (primero ? " bg-oro/10" : "") + '">' +
        '<div class="flex h-[12.25rem] w-full items-end justify-center pt-9 sm:h-[15.25rem]">' +
        '<div data-barra="' + alto + '" class="relative min-h-1 w-[64%] max-w-[4.75rem] rounded-xl transition-[height] duration-700 ease-out ' + TONOS[Math.min(i, TONOS.length - 1)] + '" style="height:' + (reducido ? alto : 0) + '%">' +
        '<span class="absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap font-display text-[1.3rem] font-bold leading-none text-tinta sm:text-[1.7rem]">' + x.pct + "%</span></div></div>" +
        '<p class="mt-3 text-balance text-center text-[0.74rem] font-bold leading-snug text-tinta sm:text-sm">' + esc(x.a.nombre) + "</p>" +
        (primero && R.empieza_aqui ? '<span class="mt-2 rounded-full bg-oro px-2.5 py-1 text-center text-[0.56rem] font-bold uppercase leading-tight tracking-[0.12em] text-tinta sm:text-[0.6rem]">' + esc(R.empieza_aqui) + "</span>" : "") +
        "</li>";
    }).join("");
    var linea = function (pos, valor) {
      return '<div class="absolute inset-x-0 border-t border-pergamino" style="top:' + pos + '%"><span class="absolute -top-2 left-0 hidden text-[0.62rem] text-humo sm:block">' + valor + "</span></div>";
    };
    return '<div class="card-luz flex flex-col p-5 sm:p-8">' +
      (R.mapa_rotulo ? '<p class="' + ROTULO + ' text-orooscuro">' + esc(R.mapa_rotulo) + "</p>" : "") +
      (R.mapa_titulo ? '<h3 class="mt-2 text-lg font-bold text-tinta">' + esc(R.mapa_titulo) + "</h3>" : "") +
      '<div class="flex flex-1 flex-col justify-center"><div class="relative mt-4 sm:pl-8">' +
      '<div aria-hidden="true" class="pointer-events-none absolute inset-x-0 top-12 h-40 sm:h-52">' +
      [0, 25, 50, 75, 100].filter(function (v) { return v <= tope; }).map(function (v) { return linea(100 - (v / tope) * 100, v); }).join("") + "</div>" +
      '<ol class="relative grid grid-cols-4 gap-1.5 sm:gap-4" aria-label="' + esc(R.mapa_titulo || "") + '">' + columnas + "</ol></div>" +
      (r.principal.a.orientacion ? '<p class="mx-auto mt-4 max-w-md text-pretty text-center text-xs leading-relaxed text-humo sm:text-[0.8rem]">' + esc(r.principal.a.orientacion) + "</p>" : "") +
      "</div></div>";
  }

  function guia(a, s) {
    return '<aside class="flex flex-col rounded-[18px] bg-bosque p-6 text-crema sm:p-8">' +
      (R.guia_rotulo ? '<p class="' + ROTULO + ' text-oro">' + esc(R.guia_rotulo) + "</p>" : "") +
      '<p class="font-display mt-4 text-balance text-[2rem] font-bold uppercase leading-[1.05] tracking-[0.03em] text-crema">' + esc(a.nombre) + "</p>" +
      (R.porque_rotulo ? '<p class="mt-3 ' + ROTULO + ' text-oro">' + esc(R.porque_rotulo) + "</p>" : "") +
      (R.porque ? '<p class="mt-1.5 text-sm leading-relaxed text-crema/85">' + rellenar(R.porque, a, s) + "</p>" : "") +
      '<hr class="my-5 border-crema/15">' +
      (R.paso_rotulo ? '<p class="' + ROTULO + ' text-oro">' + esc(R.paso_rotulo) + "</p>" : "") +
      '<p class="mt-2 text-sm leading-relaxed text-crema/85"><strong class="block font-bold text-crema">' + rellenar(R.paso_titulo || "", a, s) + "</strong>" + rellenar(R.paso_texto || "", a, s) + "</p>" +
      (R.animo ? '<p class="mt-4 text-sm font-bold text-oro">' + rellenar(R.animo, a, s) + "</p>" : "") +
      (R.animo_texto ? '<p class="mt-1 text-xs leading-relaxed text-crema/75">' + rellenar(R.animo_texto, a, s) + "</p>" : "") +
      '<a href="' + esc(a.programa_url) + '" data-q="ficha" class="btn btn-oro mt-5 w-full"><span class="relative z-10 inline-flex items-center gap-2.5">' + esc(R.boton || a.nombre) + " " + (iconos.flecha || "") + "</span></a>" +
      (fotos[a.codigo] ? '<div class="relative mt-4 aspect-[5/2] overflow-hidden rounded-2xl">' + fotos[a.codigo] +
        (R.foto_texto ? '<span class="absolute bottom-3 left-3 rounded-full bg-bosque/90 px-4 py-2 text-[0.66rem] font-bold uppercase tracking-[0.16em] text-crema">' + esc(R.foto_texto) + "</span>" : "") + "</div>" : "") +
      "</aside>";
  }

  function ruta(a, s) {
    var paso = function (n, rotulo, prog, texto, tono) {
      return '<li class="flex items-start gap-4"><span class="grid h-9 w-9 flex-none place-items-center rounded-full text-sm font-bold ' + tono + '">' + n + "</span>" +
        '<div class="min-w-0"><p class="font-brand text-[0.6rem] font-bold uppercase tracking-[0.18em] text-humo">' + esc(rotulo) + "</p>" +
        '<p class="mt-1 text-lg font-bold leading-snug text-tinta">' + esc(prog) + "</p>" +
        (texto ? '<p class="mt-1 text-xs leading-relaxed text-humo">' + esc(texto) + "</p>" : "") + "</div></li>";
    };
    return '<div class="card-luz mt-4 p-6 sm:mt-5 sm:p-8">' +
      (R.ruta_rotulo ? '<p class="' + ROTULO + ' text-orooscuro">' + esc(R.ruta_rotulo) + "</p>" : "") +
      '<ol class="mt-5 grid gap-4 md:grid-cols-[minmax(0,1fr)_minmax(4rem,14rem)_minmax(0,1fr)] md:items-center md:gap-8">' +
      paso(1, R.ahora || "", a.nombre, a.ruta_ahora, "bg-oro text-tinta") +
      '<li aria-hidden="true" class="flex items-center pl-[0.6rem] text-bosque/45 md:pl-0"><span class="hidden h-px flex-1 bg-bosque/30 md:block"></span><span class="-ml-1 rotate-90 md:rotate-0">' + (iconos.flecha || "") + "</span></li>" +
      paso(2, s.cuando || "", s.nombre, s.ruta_despues, "bg-salvia/45 text-bosque") +
      "</ol></div>";
  }

  function resultado() {
    var r = resultadoCalculado();
    if (!r.principal) return portada();
    var a = r.principal.a;
    var s = r.segundo ? r.segundo.a : a;
    // Si el registro del correo en la tienda falla, se ofrece reintentarlo o corregirlo.
    var correoBloque = "";
    if (datos.correo && envio === "error") {
      correoBloque = '<div class="mx-auto mb-8 max-w-3xl rounded-2xl border border-[#8c2f1f]/40 bg-[#8c2f1f]/5 p-4 text-sm leading-relaxed text-tinta"><p role="alert">' + esc(T.correo_fallo) + "</p>" +
        '<div class="mt-3 flex flex-wrap gap-4"><button type="button" data-q="reintentar" class="text-xs font-bold uppercase tracking-[0.14em] text-orooscuro hover:text-tinta">' + esc(T.reintentar) + "</button>" +
        '<button type="button" data-q="corregir" class="text-xs font-bold uppercase tracking-[0.14em] text-orooscuro hover:text-tinta">' + esc(T.corregir) + "</button></div></div>";
    }
    // Titular: cada frase en su línea («Quieres avanzar.» / «Empieza por tu energía.»).
    var titular = esc(a.titular).replace(/([.!?])\s+(?=\S)/g, "$1<br>");
    return '<div class="qz-step mx-auto max-w-[70rem]">' + correoBloque +
      '<div class="text-center">' +
      (R.rotulo ? '<p class="' + ROTULO + ' text-orooscuro">' + esc(R.rotulo) + "</p>" : "") +
      '<h2 tabindex="-1" class="font-display mt-4 text-balance text-[clamp(2rem,4.2vw,3rem)] font-bold leading-[1.1] text-tinta outline-none">' + titular + "</h2>" +
      (R.sub ? '<p class="mx-auto mt-4 max-w-2xl text-pretty leading-relaxed text-humo">' + rellenar(R.sub, a, s) + "</p>" : "") + "</div>" +
      '<div class="mt-8 grid gap-4 sm:gap-5 lg:grid-cols-[minmax(0,1.65fr)_minmax(0,1fr)]">' + mapa(r) + guia(a, s) + "</div>" +
      ruta(a, s) +
      (R.aviso ? '<p class="mt-6 text-center text-xs leading-relaxed text-humo">' + esc(R.aviso) + "</p>" : "") +
      '<button type="button" data-q="reiniciar" class="mx-auto mt-4 flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.16em] text-humo transition-colors hover:text-tinta">↻ ' + esc(T.reiniciar) + "</button></div>";
  }

  function pintar(aviso) {
    if (paso === -1) caja.innerHTML = portada();
    else if (paso >= 0 && paso < P.length) caja.innerHTML = pregunta(aviso);
    else if (paso === 80) caja.innerHTML = pasoDatos();
    else if (paso === 90) caja.innerHTML = calculando();
    else caja.innerHTML = resultado();
    // Las barras del mapa crecen hasta su porcentaje al aparecer.
    var barras = caja.querySelectorAll("[data-barra]");
    if (barras.length && !reducido) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          barras.forEach(function (el) { el.style.height = el.getAttribute("data-barra") + "%"; });
        });
      });
    }
    var titulo = caja.querySelector("h2[tabindex]");
    if (titulo && paso >= 0 && !aviso) titulo.focus({ preventScroll: true });
  }

  function ir(n) {
    paso = n;
    pintar();
    guardar();
    var r = caja.getBoundingClientRect();
    // La cabecera es fija: si la tarjeta queda debajo de ella (o muy abajo), se lleva justo bajo la cabecera.
    var cab = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-h")) || 72;
    if (r.top < cab + 8 || r.top > innerHeight * 0.6) caja.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "start" });
    if (n === 90) setTimeout(function () { ir(99); }, 1200);
    if (n === 99) {
      var res = resultadoCalculado();
      medir("resultado", { programa: res.principal ? res.principal.a.nombre : "", segundos: inicio ? Math.round((Date.now() - inicio) / 1000) : null });
    }
  }

  function marcarError(id, texto) {
    var el = caja.querySelector("#" + id);
    var ayuda = caja.querySelector('[data-ayuda="' + id + '"]');
    if (el) { el.setAttribute("aria-invalid", "true"); el.classList.add("border-[#8c2f1f]"); }
    if (ayuda) { ayuda.textContent = texto; ayuda.className = "mt-1.5 text-xs font-semibold text-[#8c2f1f]" + (id === "qz-autorizo" ? " ml-8" : ""); ayuda.setAttribute("role", "alert"); }
  }

  caja.addEventListener("click", function (e) {
    var op = e.target.closest("[data-op]");
    if (op) {
      if (avance) return;
      var enPaso = paso;
      resp[paso] = Number(op.getAttribute("data-op"));
      // Se marca la elección en su sitio (sin redibujar la tarjeta, que repetía su animación de entrada).
      caja.querySelectorAll("[data-op]").forEach(function (x) {
        var on = x === op;
        x.setAttribute("aria-pressed", String(on));
        CLASE_OFF.forEach(function (c) { x.classList.toggle(c, !on); });
        CLASE_ON.forEach(function (c) { x.classList.toggle(c, on); });
      });
      guardar();
      // Avance automático: se ve la elección un instante y pasa a la siguiente.
      avance = setTimeout(function () {
        avance = null;
        if (paso !== enPaso) return;
        medir("pregunta", { numero: paso + 1 });
        ir(paso === P.length - 1 ? 80 : paso + 1);
      }, reducido ? 80 : 250);
      return;
    }
    var ficha = e.target.closest('a[data-q="ficha"]');
    if (ficha) { medir("ficha", { destino: ficha.getAttribute("href") }); return; }
    var b = e.target.closest("button[data-q]");
    if (!b) return;
    var accion = b.getAttribute("data-q");
    if (accion === "empezar") {
      inicio = Date.now();
      medir("inicio");
      ir(resp.indexOf(null) === -1 ? P.length - 1 : Math.max(0, resp.indexOf(null)));
    } else if (accion === "atras") { if (avance) { clearTimeout(avance); avance = null; } ir(paso === 0 ? -1 : paso - 1); }
    else if (accion === "continuar") {
      if (resp[paso] === null) { pintar(true); return; }
      medir("pregunta", { numero: paso + 1 });
      ir(paso === P.length - 1 ? 80 : paso + 1);
    } else if (accion === "reintentar") {
      if (enviarLead()) caja.innerHTML = calculando();
      else pintar();
    } else if (accion === "corregir") ir(80);
    else if (accion === "reiniciar") {
      resp = P.map(function () { return null; });
      datos = { edad: "", pais: "", genero: "", correo: "", autorizo: false, novedades: false };
      envio = "";
      inicio = 0;
      try { sessionStorage.removeItem(CLAVE); } catch (e) {}
      ir(-1);
    }
  });

  caja.addEventListener("submit", function (e) {
    e.preventDefault();
    var f = e.target;
    var edad = f.querySelector("#qz-edad").value;
    var pais = f.querySelector("#qz-pais").value;
    var generoEl = f.querySelector('input[name="genero"]:checked');
    var correo = (f.querySelector("#qz-email").value || "").trim();
    var autorizo = f.querySelector("#qz-autorizo").checked;
    var casillaNovedades = f.querySelector("#qz-novedades");
    var novedades = T.registro === "siempre" || !!(casillaNovedades && casillaNovedades.checked);
    var primero = null;
    var falla = function (id, texto) { marcarError(id, texto); if (!primero) primero = id; };
    if (!edad) falla("qz-edad", T.campo_error);
    if (!pais) falla("qz-pais", T.campo_error);
    if (!generoEl) falla("qz-genero-0", T.campo_error);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(correo)) falla("qz-email", T.correo_error);
    if (!autorizo) falla("qz-autorizo", T.autorizo_error);
    datos = { edad: edad, pais: pais, genero: generoEl ? generoEl.value : "", correo: correo, autorizo: autorizo, novedades: novedades };
    guardar();
    if (primero) {
      var el = caja.querySelector("#" + primero);
      if (el) el.focus();
      return;
    }
    // Mientras la tienda recibe el formulario se ve «calculando»; al volver, el resultado.
    caja.innerHTML = calculando();
    if (!enviarLead()) ir(99);
  });

  recuperar();
  // ---- Vuelta del envío ---------------------------------------------------
  var volvio = /[?&](customer|contact)_posted=true/.test(location.search);
  if (envio === "enviando") {
    envio = volvio && !document.querySelector("[data-test-envio-error]") ? "ok" : "error";
    if (resp.indexOf(null) === -1) paso = 99;
    guardar();
  }
  if (volvio && window.history && history.replaceState) history.replaceState(null, "", location.pathname);
  if (paso === 99) { ir(99); return; }
  // La portada ya llega pintada desde la sección; solo se redibuja si hay que retomar otro paso.
  if (paso !== -1 || !caja.querySelector('[data-q="empezar"]')) pintar();
})();
